import { defineComponent as _defineComponent } from 'vue'
declare const config: { version?: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'TopNavbar',
  setup(__props) {

const version = typeof config !== 'undefined' ? config.version : '';

return { __sfc: true,version }
}

})